import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabOrgao = '/service/contabilidade/taborgao/'

class OrgaosService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getOrgaos(exercicio) {
        return this.conex.get(urlTabOrgao + 'recuperarporexercicios/' + exercicio)
    }
}

export default OrgaosService
